import { render, staticRenderFns } from "./novoNumeroProibido.vue?vue&type=template&id=f7d3c8e6"
import script from "./novoNumeroProibido.vue?vue&type=script&lang=js"
export * from "./novoNumeroProibido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports